import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get, orderBy } from "lodash";
import { Link } from "react-router-dom";
import { Sorty } from "../../../common/js/icons";
import { buildAddress } from "../utils/operations";
import schema from "./reviewCompsTables";

const StyledListingIdLink = styled("span")({
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
    },
    color: "#2C99D2",
    fontWeight: 600,
});

const StyledAlternateContent = styled("div")({
    margin: "auto",
    textAlign: "center",
    marginTop: "4em",
    marginBottom: "1em",
});

const StyledLink = styled(Link)({
    textDecoration: "none",
});

const StyledSortable = styled("span")({
    paddingRight: "5px",
    paddingBottom: "3px",
});

const StyledTableContainer = styled("div")({
    width: "100%",
    overflowX: "auto",
});

const StyledTableWrapper = styled("div")({
    width: "100%",
    display: "flex",
    flexDirection: "column",
});

const CompsTable = (props) => {
    const { handleSort, isLoading, comps, compTab } = props;

    let columnToSort = "transactionDate";
    let sortDirection = "asc";

    let compz = orderBy(comps, columnToSort, sortDirection);

    return (
        <div>
            <div style={{ display: "flex", width: "100%" }}>
                <div style={{ flex: "1 1 auto" }}>
                    <div className="simPaper">
                        <StyledTableContainer>
                            <StyledTableWrapper>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {schema.viewHeaders[compTab].map((x, i) => (
                                                <TableCell key={`thc-${i}`}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                        onClick={() => handleSort(x.sort ? x.sort : x.prop)}
                                                    >
                                                        <StyledSortable>{x.name}</StyledSortable>
                                                        {x.name && (
                                                            <div>
                                                                <Sorty />
                                                            </div>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    {!isLoading && (
                                        <TableBody>{compz.map((x, i) => row(x, i, compTab, isLoading))}</TableBody>
                                    )}
                                </Table>
                            </StyledTableWrapper>
                        </StyledTableContainer>
                        {isLoading ? (
                            <StyledAlternateContent>
                                <CircularProgress color="primary" />
                            </StyledAlternateContent>
                        ) : Object.keys(compz).length > 0 ? null : (
                            <StyledAlternateContent>Nothing to show.</StyledAlternateContent>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const row = (x, index, compTab, isLoading) => {
    return isLoading ? null : (
        <TableRow key={`tr-${index}`} selectable="false">
            {schema.viewHeaders[compTab].map((y, k) =>
                y.name === "Address" ? (
                    <TableCell key={`trc-${k}`}>
                        <StyledLink to={`/comp/${x.dealKey}`}>
                            <StyledListingIdLink>{get(x, "listing.listingName", null)}</StyledListingIdLink>
                        </StyledLink>
                        <div>{buildAddress(get(x, "listing.property.primaryAddress", {}))}</div>
                    </TableCell>
                ) : y.transform ? (
                    <TableCell key={`trc-${k}`}>{y.transform(get(x, y.prop))}</TableCell>
                ) : (
                    //no transform function
                    <TableCell key={`trc-${k}`}>{get(x, y.prop)}</TableCell>
                )
            )}
        </TableRow>
    );
};

export default CompsTable;
